import { render, staticRenderFns } from "./BankDataEdit.vue?vue&type=template&id=b1d0ee54&scoped=true&"
import script from "./BankDataEdit.vue?vue&type=script&lang=js&"
export * from "./BankDataEdit.vue?vue&type=script&lang=js&"
import style0 from "./BankDataEdit.vue?vue&type=style&index=0&id=b1d0ee54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d0ee54",
  null
  
)

export default component.exports